import http from '../http'
import CampaignGroup from '@/services/classes/CampaignGroup'

export default {
  index: async () => {
    const { data } = await http.get('/api/private/v1/campaign-groups')
    return data.data.map((campaignGroup) => new CampaignGroup(campaignGroup))
  },
  store: async (name) => {
    const { data } = await http.post('/api/private/v1/campaign-groups', { name })
    return { items: new CampaignGroup(data.data) }
  },
  edit: async ({ id, name }) => {
    const { data } = await http.put(`/api/private/v1/campaign-groups/${id}`, { name })
    return { items: new CampaignGroup(data.data) }
  },
  delete: async (id) => {
    const { data } = await http.delete(`/api/private/v1/campaign-groups/${id}`)
    return { items: new CampaignGroup(data.data) }
  },
  pushCampaignsToGroup: async ({ campaignGroupId, campaignsIds }) => {
    await http.post(`/api/private/v1/campaign-groups/${campaignGroupId}/campaigns`, {
      campaigns: campaignsIds
    })
  }
}
